import { FC, useMemo } from "react";
import { SubmitHandler } from "react-hook-form";

import { FormBuilder, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { IVenueSearchQuery } from "Bands/contexts";

import { getFields } from "./formData";
import { VenueSearchFormContainer } from "./styles";

const { venueBlock } = copy;

interface VenueSearchFormProps {
  defaultValues?: Record<string, any>;
  handleSubmit: SubmitHandler<IVenueSearchQuery>;
}

export const VenueSearchForm: FC<VenueSearchFormProps> = ({ defaultValues, handleSubmit }) => {
  const fields = useMemo(() => getFields(), []);
  const buttons: IFormButtons = {
    primary: {
      children: venueBlock.search.cta,
      size: "m",
    },
  };

  return (
    <VenueSearchFormContainer>
      <Spacer size="m">
        <Title asComponent="h3" size="m">
          {venueBlock.search.titleVenue}
        </Title>
        <FormBuilder
          fields={fields}
          submitMode="isDirty"
          onSubmit={handleSubmit}
          buttons={buttons}
          defaultValues={defaultValues}
          inlineForm
        />
      </Spacer>
    </VenueSearchFormContainer>
  );
};
